// Shipping charge calculation utility
export const calculateShippingCharges = (subtotal) => {
  if (subtotal >= 1000) {
    return {
      shippingCharges: 0,
      isFreeShipping: true,
      message: "Free Shipping"
    };
  } else if (subtotal >= 500) {
    return {
      shippingCharges: 75,
      isFreeShipping: false,
      message: "Standard Shipping"
    };
  } else {
    return {
      shippingCharges: 100,
      isFreeShipping: false,
      message: "Standard Shipping"
    };
  }
};

export const getShippingMessage = (subtotal) => {
  if (subtotal >= 1000) {
    return "Free shipping on orders above ₹1000";
  } else if (subtotal >= 500) {
    return `Add ₹${1000 - subtotal} more for free shipping`;
  } else {
    return `Add ₹${500 - subtotal} more for ₹75 shipping or ₹${1000 - subtotal} more for free shipping`;
  }
}; 